module.exports = __webpack_public_path__ + "img/shdl-kr.29ddc496.jpg";